import { AnnotationEntryResponse } from '../../annotations';
import { DescribeProperty } from '../../common';
import { Model3dEntryResponse } from '../../models3d';

export class ProjectEntryResponse {
  @DescribeProperty({
    description: 'The ID of created project',
    example: '123e4567-e89b-12d3-a456-426614174000',
    type: 'string',
    format: 'uuid',
  })
  id: string;

  @DescribeProperty({
    description: 'The name of the project',
    example: 'Example project name',
  })
  name: string | null;

  @DescribeProperty({
    description: 'Associated 3d model entries',
    type: [Model3dEntryResponse],
  })
  model3dEntries?: Model3dEntryResponse[];

  @DescribeProperty({
    description: 'Associated annotation entries',
    type: [AnnotationEntryResponse],
  })
  annotationEntries?: AnnotationEntryResponse[];

  @DescribeProperty({
    description: 'Readonly flag for the project',
    example: 'false',
  })
  readonly: boolean;

  @DescribeProperty({
    description: 'Enable fp64 (Double floating point precision) for the project',
    example: 'false',
  })
  enableFp64: boolean;

  @DescribeProperty({
    description: 'Enable PBR (Physically based rendering) for the project',
    example: 'false',
  })
  enablePbr: boolean;

  @DescribeProperty({
    description: 'Show edges for the project',
    example: 'false',
  })
  showEdges: boolean;

  @DescribeProperty({
    description: 'Show bounding box for the project',
    example: 'false',
  })
  showBoundingBox: boolean;

  @DescribeProperty({
    description: 'Camera far clipping plane distance for the project',
    example: '2000',
  })
  cameraFarDistance: number;

  @DescribeProperty({
    description: 'Disable the camera far clipping plane for the project',
    example: 'false',
  })
  cameraFarDisabled: boolean;

  @DescribeProperty({ description: 'Updated at', type: 'string', format: 'date-time' })
  updatedAt: Date;

  @DescribeProperty({ description: 'Created at', type: 'string', format: 'date-time' })
  createdAt: Date;
}
